module.exports = __webpack_public_path__ + "img/hero-join-us.2175c23.png";